import { combineReducers } from 'redux';
import userProfile from './user-profile/reducer';
import classroomInfo from './classroom-information/reducers';

export default combineReducers({ userProfile, classroomInfo });
